<template>
  <div class="schedule-wrap container flex">
    <div class="schedule-item schedule-info">
      <div class="title">
        <span
          >{{
            langSet == "cn" ? "展览与活动时间" : "Exhibition and Event Schedule"
          }}
        </span>
      </div>
      <img
        class="home-exhibition-time"
        :src="
          langSet == 'cn'
            ? require('../../../assets/imgs/schedule_cn.png')
            : require('../../../assets/imgs/schedule_en.png')
        "
        alt=""
      />
    </div>
    <!-- 仅新增 ref="swiperBox" 其余不动 -->
    <div class="schedule-item schedule-swiper" ref="swiperBox">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in list"
          :key="item.id"
          :data-id="item.id"
          @click="toLink(item)"
        >
          <img :src="langSet == 'cn' ? item.image : item.en_image" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "../../../../node_modules/swiper/css/swiper.min.css";
export default {
  props: {
    webData: Object,
    list: Array,
  },
  components: {},
  data() {
    return {
      langSet: "",
      mySwiper: null,
    };
  },
  watch: {
    // 加deep深度监听，数组修改也能触发
    list: {
      handler() {
        this.$nextTick(() => {
          this.createSwiper();
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.langSet = this.$language;
    // dom渲染完成再初始化
    this.$nextTick(() => {
      this.createSwiper();
    });
    console.log(this.list);
  },
  methods: {
    createSwiper() {
      if (this.mySwiper) {
        this.mySwiper.destroy(true, true);
        this.mySwiper = null;
      }
      if (!this.list || this.list.length < 2) {
        return;
      }
      const dom = this.$refs.swiperBox;
      if (!dom) {
        return;
      }
      this.mySwiper = new Swiper(dom, {
        spaceBetween: 0,
        loop: true,
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
      });
    },
    toLink(item, index) {
      if (item.url_type == 1) {
        this.$router.push({
          path: this.langSet == "cn" ? item.url : item.en_url,
        });
      } else if (item.url_type == 2) {
        window.open(this.langSet == "cn" ? item.url : item.en_url, "_blank");
      } else if (item.url_type == 0) {
        return false;
      }
    },
  },
  beforeDestroy() {
    if (this.mySwiper) {
      this.mySwiper.destroy(true, true);
      this.mySwiper = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.schedule-wrap {
  margin: 67px auto 120px;
  gap: 40px;
  justify-content: space-between;
  .schedule-item {
    width: calc((100% - 40px) / 2);
    height: 286px;
    .home-exhibition-time {
      width: 100%;
      margin-top: 30px;
    }
  }
  .schedule-info {
    padding: 15px 50px;
    box-sizing: border-box;
    background: url("../../../assets/imgs/schedule_bg.png") no-repeat;
    background-size: 100% 100%;
    .title {
      font-weight: 600;
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
      position: relative;
      span {
        position: relative;
        z-index: 2;
      }
      &::after {
        content: "";
        position: absolute;
        top: -42px;
        left: -20px;
        width: 112px;
        height: 88px;
        background: url("../../../assets/imgs/schedule_icon.png") no-repeat;
        background-size: 100%;
      }
    }
  }
  .schedule-swiper {
    overflow: hidden;
    border-radius: 100px 100px 100px 0px;
    .swiper-wrapper {
      // display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      flex-wrap: nowrap;
      transition-property: transform;
      box-sizing: content-box;
    }
    .swiper-slide {
      width: 100% !important;
      text-align: center;
      font-size: 18px;
      background: #fff;
      cursor: pointer;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      // -webkit-justify-content: center;
      // justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 767px) {
  .schedule-wrap {
    gap: 0;
    flex-wrap: wrap;
    margin: 0.6rem auto;
    .schedule-item {
      width: 100%;
      height: 3rem;
      padding: 10px 30px;
      margin-bottom: 0.3rem;
      .home-exhibition-time {
        margin-top: 0;
      }
    }
    .schedule-info {
      .title {
        font-size: 0.3rem;
        &::after {
          width: 75px;
          top: -28px;
        }
      }
    }
    .schedule-swiper {
      padding: 0;
      border-radius: 60px 60px 60px 0px;
    }
  }
}
</style>